import { Component } from '@angular/core';

@Component({
  selector: 'lib-loading-topic',
  templateUrl: './loading-topic.component.html',
  styleUrls: ['./loading-topic.component.scss']
})
export class LoadingTopicComponent {}
